import type { Recipe } from '../types/recipe';

export const sampleRecipes: Omit<Recipe, 'id' | 'createdAt' | 'updatedAt'>[] = [
  {
    title: 'Mango Banana Smoothie',
    category: 'Smoothies',
    ingredients: [
      { name: 'Ripe Mango', quantity: 1, unit: 'piece' },
      { name: 'Ripe Banana', quantity: 2, unit: 'pieces' },
      { name: 'Orange Juice', quantity: 1, unit: 'cup' },
      { name: 'Water', quantity: 1, unit: 'cup' },
    ],
    instructions: [
      'Peel and chop the mango and bananas',
      'Add all ingredients to a blender',
      'Blend until smooth and creamy',
      'Add more water if needed for desired consistency',
    ],
    cookingTime: 0,
    prepTime: 5,
    servings: 2,
    difficulty: 'easy',
    dietaryTags: ['vegan', 'raw', 'fruit-based']
  },
  {
    title: 'Grape Fruit Salad',
    category: 'Fruit Dishes',
    ingredients: [
      { name: 'Red Grapes', quantity: 2, unit: 'cups' },
      { name: 'Green Grapes', quantity: 2, unit: 'cups' },
      { name: 'Orange', quantity: 2, unit: 'pieces' },
      { name: 'Apple', quantity: 1, unit: 'large' },
      { name: 'Mint Leaves', quantity: 4, unit: 'pieces' },
    ],
    instructions: [
      'Wash all fruits thoroughly',
      'Cut grapes in half if desired',
      'Peel and segment oranges',
      'Core and dice apple into bite-sized pieces',
      'Combine all fruits in a large bowl',
      'Garnish with fresh mint leaves',
      'Chill before serving',
    ],
    cookingTime: 0,
    prepTime: 15,
    servings: 4,
    difficulty: 'easy',
    dietaryTags: ['vegan', 'raw', 'fruit-based']
  },
  {
    title: 'Herbal Detox Tea',
    category: 'Teas',
    ingredients: [
      { name: 'Fresh Ginger', quantity: 1, unit: 'inch' },
      { name: 'Lemon', quantity: 1, unit: 'piece' },
      { name: 'Mint Leaves', quantity: 5, unit: 'pieces' },
      { name: 'Honey', quantity: 1, unit: 'tbsp' },
      { name: 'Water', quantity: 2, unit: 'cups' },
    ],
    instructions: [
      'Slice ginger thinly',
      'Bring water to a boil in a pot',
      'Add ginger and simmer for 5 minutes',
      'Remove from heat and add mint leaves',
      'Let steep for 3-5 minutes',
      'Strain into a cup',
      'Add honey and lemon juice to taste',
    ],
    cookingTime: 10,
    prepTime: 5,
    servings: 2,
    difficulty: 'easy',
    dietaryTags: ['herbal', 'detox']
  },
  {
    title: 'Rainbow Salad Bowl',
    category: 'Salads',
    ingredients: [
      { name: 'Mixed Greens', quantity: 4, unit: 'cups' },
      { name: 'Cherry Tomatoes', quantity: 1, unit: 'cup' },
      { name: 'Cucumber', quantity: 1, unit: 'medium' },
      { name: 'Avocado', quantity: 1, unit: 'large' },
      { name: 'Red Bell Pepper', quantity: 1, unit: 'medium' },
      { name: 'Purple Cabbage', quantity: 1, unit: 'cup' },
      { name: 'Lemon Juice', quantity: 2, unit: 'tbsp' },
      { name: 'Olive Oil', quantity: 1, unit: 'tbsp' },
    ],
    instructions: [
      'Wash and dry all vegetables',
      'Chop mixed greens into bite-sized pieces',
      'Halve cherry tomatoes',
      'Slice cucumber into thin rounds',
      'Dice avocado',
      'Julienne bell pepper',
      'Shred purple cabbage',
      'Arrange all vegetables in a bowl',
      'Drizzle with lemon juice and olive oil',
      'Toss gently before serving',
    ],
    cookingTime: 0,
    prepTime: 20,
    servings: 2,
    difficulty: 'medium',
    dietaryTags: ['vegan', 'raw', 'oil-free-option']
  },
  {
    title: 'Fruit Platter Deluxe',
    category: 'Platters',
    ingredients: [
      { name: 'Watermelon', quantity: 1, unit: 'quarter' },
      { name: 'Pineapple', quantity: 1, unit: 'medium' },
      { name: 'Strawberries', quantity: 2, unit: 'cups' },
      { name: 'Blueberries', quantity: 1, unit: 'cup' },
      { name: 'Green Grapes', quantity: 2, unit: 'cups' },
      { name: 'Kiwi', quantity: 3, unit: 'pieces' },
      { name: 'Mint Leaves', quantity: 8, unit: 'pieces' },
    ],
    instructions: [
      'Wash all fruits thoroughly',
      'Cut watermelon into triangles',
      'Peel and slice pineapple into rings',
      'Hull and halve strawberries if large',
      'Peel and slice kiwis',
      'Arrange fruits decoratively on a large platter',
      'Garnish with fresh mint leaves',
    ],
    cookingTime: 0,
    prepTime: 30,
    servings: 8,
    difficulty: 'medium',
    dietaryTags: ['vegan', 'raw', 'fruit-based']
  }
];